import { VoidComponent } from "solid-js";
import { TextButton } from "../../../../../../../components/button/Button";
import { useTranslation } from "../../../../../../../state/i18n";

const ChoosePlanAction: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <TextButton
      text={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_ACTION_CHOOSE_PLAN_LABEL)}
      variant="secondary"
      size="medium"
      class="border-status-upgrade text-status-upgrade hover:border-status-upgrade"
    />
  );
};

export default ChoosePlanAction;
